import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  Col,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import DatePicker from "react-datepicker";
import CopyWrapper from "components/Common/CopyWrapper";
import noImageJob from "../../../../assets/images/no-job-post.png";
import { COLOR_STATUS_JOB_POST, ENUM_STATUS_JOB_POST, LIST_OPTION_STATUS_JOB_POST, PLAN_FEATURE_KEY_OPTION } from "helpers/constans";
import { formatDateString, formatDateStringToKorea, formatISOString } from "helpers/format";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import { toast } from "react-toastify";
import moment from "moment";

export default function JobPostSection({
  item,
  handleUpdateSuccess,
  setLinkImage,
  jobPostInfo
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);
  const [data, setData] = useState<any>(null);
  const [displayStartDate, setDisplayStartDate] = useState<any>(null);
  const [displayEndDate, setDisplayEndDate] = useState<any>(null);
  
  const handleUpdateDatePostJob = async () => {
    if (!data?.jobPostId || !data?.planPurchaseId) return;

    try {
      setIsLoadingSave(true)

      const formatData = {
        jobPostId: data?.jobPostId,
        displayStartDate: displayStartDate ? formatDateString(displayStartDate) : null,
        displayEndDate: displayEndDate ? formatDateString(displayEndDate) : null,
      }
      
      const response: any = await userPlanPurchaseApi.putUserPlanPurchase(data?.planPurchaseId, {
        jobPost: formatData
      });

      if (response?.data) {
        handleUpdateSuccess && handleUpdateSuccess();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    } finally {
      setIsLoadingSave(false)
    }
  };

  const isUpdateDisplayDate = () => {
    let statusOld = data?.status;
    if(statusOld == ENUM_STATUS_JOB_POST.ACTIVE && data?.displayStartDate) {
      const currentDate = moment(moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss'));
      const applicationStartDate = (data?.displayStartDate);

      if(currentDate.isBefore(moment(applicationStartDate))) {
        statusOld = ENUM_STATUS_JOB_POST.SCHEDULE
      }
    }

    if([ENUM_STATUS_JOB_POST.SCHEDULE].includes(statusOld)) return true;

    return false;
  }

  useEffect(() => {
    if (item) {
      const displayStartDate = jobPostInfo?.displayStartDate ? moment.utc(jobPostInfo?.displayStartDate).startOf("day").toDate() : null;
      const displayEndDate = jobPostInfo?.displayEndDate ? moment.utc(jobPostInfo?.displayEndDate).startOf("day").toDate() : null;
      setDisplayStartDate(displayStartDate)
      setDisplayEndDate(displayEndDate)
      setData({
        jobPostId: item?.jobPostId,
        planPurchaseId: item?.planPurchaseId,
        featureKey: item?.featureKey,
        jobAttachment: jobPostInfo?.jobAttachment?.length > 0 ? jobPostInfo?.jobAttachment?.[0]?.url : "",
        jobTitle: jobPostInfo?.title,
        status: jobPostInfo?.status,
        createdAt: jobPostInfo?.createdAt,
        displayStartDate: displayStartDate,
        displayEndDate: displayEndDate,
      })
    }
  }, [item]);

  return (
    <div>
      <span className="text-white bg-orange px-3 py-1 d-inline-block">
        {t(
          PLAN_FEATURE_KEY_OPTION?.find(
            (item: any) => String(item?.value) === String(data?.featureKey)
          )?.label || ""
        )}
      </span>
      <Card style={{ borderTopLeftRadius: 0 }}>
        <CardBody>
          <div>
            <div>
              <div className="my-3 d-flex flex-column flex-lg-row gap-4 gap-lg-4">
                <div
                  className="position-relative cursor-pointer"
                  style={{
                    minWidth: "140px",
                    width: "140px",
                    height: "140px",
                    // border: "1px solid var(--vz-input-border-custom)",
                    overflow: "hidden",
                    borderRadius: "var(--vz-border-radius)",
                  }}
                  onClick={() => setLinkImage && setLinkImage({ url: data?.jobAttachment || "" })}
                >
                  <img
                    className=""
                    src={data?.jobAttachment || noImageJob}
                    alt={`preview-user`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImageJob;
                    }}
                  />
                </div>
                <Row className="w-100">
                  <Col md={12} lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="name" className="form-label">
                        {t("Job Title")}
                      </Label>
                      <div className="cursor-pointer">
                        {data?.jobTitle ? (
                          <CopyWrapper contentCopy={data?.jobTitle}>
                            {data?.jobTitle}
                          </CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md={4} lg={4}>
                    <div className="mb-3">
                      <Label htmlFor="name" className="form-label">
                        {t("Status")}
                      </Label>
                      <div className="cursor-pointer">
                        {
                          data?.status ? (
                            <span
                              className={`rounded-pill badge bg-${
                                COLOR_STATUS_JOB_POST[data?.status] || "secondary"
                              }`}
                              style={{
                                fontSize: "0.8rem",
                                lineHeight: 1
                              }}
                            >
                              {t(
                                LIST_OPTION_STATUS_JOB_POST?.find(
                                  (item: any) => (item?.value) == (data?.status)
                                )?.label || ""
                              )}
                            </span>
                          ) : "-"
                        }
                      </div>
                    </div>
                  </Col>

                  <Col md={6} lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="name" className="form-label">
                        {t("Created at")}
                      </Label>
                      <div className="cursor-pointer">
                        {data?.createdAt ? (
                          formatDateStringToKorea(
                            data?.createdAt
                          )
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </Col>

                  <Col md={4} lg={4} className="datepicker-time">
                    <div className="mb-3">
                      <Label htmlFor="displayStartDate" className="form-label">
                        {t("Display Start Date")}{" "}
                      </Label>
                      
                      <div className="cursor-pointer">
                        {
                          isUpdateDisplayDate() ? (
                            <DatePicker
                              name={"displayStartDate"}
                              className="form-control"
                              selected={displayStartDate || null}
                              placeholderText={t("Display Start Date")}
                              onChange={(date: any) => {
                                setDisplayStartDate(date)
                              }}
                              dateFormat="yyyy-MM-dd"
                            />
                          ) : (
                            displayStartDate ? (formatDateString(displayStartDate)) : "-"
                          )
                        }
                      </div>
                    </div>
                  </Col>

                  <Col md={4} lg={4} className="datepicker-time">
                    <div className="mb-3">
                      <Label htmlFor="displayEndDate" className="form-label">
                        {t("Display End Date")}{" "}
                      </Label>

                      <div className="cursor-pointer">
                        {
                          isUpdateDisplayDate() ? (
                            <DatePicker
                              name={"displayEndDate"}
                              className="form-control"
                              selected={displayEndDate || null}
                              placeholderText={t("Display Start Date")}
                              onChange={(date: any) => {
                                setDisplayEndDate(date)
                              }}
                              dateFormat="yyyy-MM-dd"
                            />
                          ) : (
                            displayEndDate ? (formatDateString(displayEndDate)) : "-"
                          )
                        }
                      </div>
                    </div>
                  </Col>
                  
                  {
                    isUpdateDisplayDate() && (
                      <Col lg={12}>
                        <div className="hstack gap-2 justify-content-end">
                          <button type="button" className="btn btn-primary fs-14"
                            onClick={() => {
                              handleUpdateDatePostJob()
                            }}
                          >
                            {isLoadingSave && (
                              <Spinner size="sm" className="me-2"></Spinner>
                            )}
                            {t("Button Save")}
                          </button>
                        </div>
                      </Col>
                    )
                  }
                  
                </Row>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
